import { createElement, useMemo } from 'react';
import './index.scss';
import arrowImg from '../../assets/icon/mine/right.png';
const MemberCard = ({ userName, gradeImg, isMaxLevel, maxTotal, currentNum, isFastExpireCoupon, discount, handleClick = () => { }, handleCouponClick = () => { }, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const progressPercentage = useMemo(() => {
        if (isMaxLevel)
            return 100;
        if (maxTotal === 0)
            return 0;
        if (!maxTotal || !currentNum)
            return 0;
        return ((currentNum / maxTotal) * 100).toFixed(2);
    }, [isMaxLevel, maxTotal, currentNum]);
    const containerWidth = isFastExpireCoupon ? '60%' : '100%';
    return (createElement("div", { className: "member-card", ..._otherProps, onClick: handleClick },
        createElement("div", { className: "header" },
            createElement("div", { className: "left" },
                createElement("span", null, userName),
                gradeImg && createElement("img", { className: "grade", src: gradeImg })),
            discount && createElement("div", { className: "btn-tag" },
                "\u5C0A\u4EAB",
                discount ?? 0,
                "\u6298")),
        createElement("div", { className: "footer" },
            createElement("div", { className: "progress-bar-container", style: { width: containerWidth } },
                createElement("div", { className: "progress-bar-background" },
                    createElement("div", { className: "progress-bar-foreground", style: { width: `${progressPercentage}%` } }))),
            isFastExpireCoupon && createElement("div", { className: "right", onClick: handleCouponClick },
                "\u60A8\u6709\u4F18\u60E0\u5238\u5373\u5C06\u5230\u671F",
                createElement("img", { className: "img", src: arrowImg })))));
};
MemberCard.displayName = 'MemberCard';
export default MemberCard;
